<template>
  <div class="excellent_box" v-if="visible">
    <div class="excellent_main upload-image-main">
      <div class="excellent_top">
        批量上传型号图片
        <i class="el-icon-close" @click.stop="close"></i>
      </div>
      <div class="excellent_content">
        <div class="image-upload-container">
          <div class="image-upload-left">
            <el-button size="big" type="primary" @click="triggerFileSelect">选择图片文件</el-button>
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="onFileSelected"
              multiple
            />
            <div slot="tip" class="el-upload__tip">
              支持 jpg、png、gif 等图片格式<br />
              文件名格式：品牌英文_型号英文<br />
              一次不得上传超过100张图片<br />
            </div>
            <div style="margin-top: 80px; text-align: center;">
              <el-button
                type="success"
                size="big"
                :loading="loading"
                :disabled="!selectedFiles || selectedFiles.length === 0"
                @click="submitUpload"
              >
                确定上传
              </el-button>
            </div>
          </div>
          <div class="image-upload-right">
            <div
              v-if="selectedFiles && selectedFiles.length > 0"
              class="selected-files"
            >
              <div class="files-header">
                已选择 {{ selectedFiles.length }} 个文件：
              </div>
              <div
                v-for="(file, index) in selectedFiles"
                :key="index"
                class="file-item"
              >
                {{ file.name }}
              </div>
            </div>
            <div v-else class="no-files">暂未选择文件</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadTypeImage",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFiles: [],
      loading: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.reset();
      }
    }
  },
  methods: {
    reset() {
      this.selectedFiles = [];
      this.loading = false;
    },

    close() {
      this.$emit("close");
    },

    triggerFileSelect() {
      this.$refs.fileInput.click();
    },

    onFileSelected(event) {
      const files = Array.from(event.target.files);
      if (!files || files.length === 0) return;

      // 验证文件类型（根据扩展名）
      const validExts = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
      const invalidFiles = files.filter(f => {
        const fileName = f.name || "";
        const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        return !validExts.includes(ext);
      });
      if (invalidFiles.length > 0) {
        this.$message.error("请选择图片格式文件（jpg、png、gif、bmp）");
        return;
      }

      this.selectedFiles = files;
    },

    submitUpload() {
      if (!this.selectedFiles || this.selectedFiles.length === 0) {
        this.$message.error("请选择要上传的文件");
        return;
      }

      this.loading = true;

      const formData = new FormData();
      // 将所有文件添加到 formData
      this.selectedFiles.forEach(file => {
        formData.append("files", file);
      });

      this.$https(this.$api.api.batchUploadTypeImage, formData, "POST", {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          this.loading = false;
          if (res.data.code == 200) {
            const data = res.data.data || {};
            const successCount = data.successCount || 0;
            const failCount = data.failCount || 0;

            if (failCount > 0) {
              this.$message.warning(
                `上传完成，成功 ${successCount} 条，失败 ${failCount} 条`
              );
              if (data.errorList && data.errorList.length > 0) {
                this.downloadErrorExcel(data.errorList);
              }
            } else {
              this.$message.success(`上传成功，共处理 ${successCount} 条`);
              this.$emit("success");
              this.close();
            }
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("上传失败：" + (err.message || "网络错误"));
        });
    },

    downloadErrorExcel(errorList) {
      this.$https(this.$api.api.exportUploadFileErrorExcel, errorList, 'FILE')
        .then(res => {
          const blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "图片上传异常报告.xlsx";
          link.click();
          window.URL.revokeObjectURL(url);
          this.$emit("success");
          this.close();
        })
        .catch(err => {
          this.$message.error(
            "导出异常报告失败：" + (err.message || "网络错误")
          );
        });
    }
  }
};
</script>

<style lang="less" scoped>
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .upload-image-main {
    width: 750px;
    max-height: 600px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 45px;
      background: #eee;
      line-height: 45px;
      padding: 5px 2%;
      font-size: 16px;
      i {
        float: right;
        margin-top: 12px;
        font-size: 22px;
        cursor: pointer;
      }
    }

    .excellent_content {
      padding: 20px;
      max-height: 510px;
      overflow-y: auto;

      .image-upload-container {
        display: flex;

        .image-upload-left {
          flex-shrink: 0;
          width: 250px;
          padding-top: 10px;

          .el-upload__tip {
            margin-top: 12px;
            font-size: 13px;
            color: #999;
            line-height: 1.6;
          }
        }

        .image-upload-right {
          position: relative;
          flex: 1;
          min-height: 100px;
          max-height: 400px;
          overflow-y: auto;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;

          .selected-files {
            .files-header {
              font-weight: bold;
              margin-bottom: 10px;
              font-size: 14px;
              color: #409eff;
            }

            .file-item {
              font-size: 13px;
              color: #666;
              padding: 4px 0;
              word-break: break-all;
            }
          }

          .no-files {
            color: #999;
            text-align: center;
            line-height: 100px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/brand/uploadTypeImageModal.vue